import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useApi } from 'stores/api';
import { isValidEmail } from 'stores/utils';

const ForgotPassword = (props) => {
    const api = useApi();
    const { t } = useTranslation(['password-forgot']);
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [sentSuccess, setSentSuccess] = useState(false);

    const onClickSendEmail = async (e) => {
        e.preventDefault()
        const newErrors = findFormErrors();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        } else {
            let result = await api.invokeResetPassword(email);
            if (result) {
                setSentSuccess(true);
            }
        }
    }

    const findFormErrors = () => {
        const newErrors = {};
        if (!isValidEmail(email)) newErrors.Email = t("validation-email");;
        return newErrors;
    }    

    return (
        <>
            {!sentSuccess && <section className="passwordForgotten-container">
                <div className="wrapper">
                    <div className="row">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("resetPassword")}</h3>
                            <div className="password-container">
                                <div className="row">
                                    <h4>{t("enterEmailAddress")}</h4>
                                </div>
                                <div className="row">
                                    <div className="label">
                                        {t("yourEmailAddress")}
                                    </div>
                                    <div className="input">
                                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} 
                                            onFocus={()=>setErrors({})} />
                                    </div>
                                    <Form.Control.Feedback type='invalid'>
                                        {errors.Email}
                                    </Form.Control.Feedback>
                                </div>
                                <div className="row passwordForgottenBtns-container">
                                    <Link className="back" to="/"><i className="fa fa-times-circle" aria-hidden="true"></i> {t("cancel")}</Link>
                                    <a className="forward" onClick={onClickSendEmail}>{t("sendEmail")}<i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>}

            {sentSuccess && <section className="passwordForgotten-container">
                <div className="wrapper">
                    <div className="row">
                        <div className="column-12">
                            <h3 className="mali-blue">{t("forgotPasswordEmail")}</h3>
                            <div className="password-container">
                                <div className="row">
                                    <h4>{t("weHaveSentEmail", { email })}</h4>
                                </div>
                                <div className="row passwordForgottenBtns-container">
                                    <Link className="forward" to="/">
                                        {t("goHome")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>}
        </>
    );
}

export default ForgotPassword;